document.addEventListener('DOMContentLoaded', function () {
    var warenkorbWarenkorb = new Warenkorb('.warenkorb-seite');
    var warenkorbShop = new Shop();
    
    warenkorbWarenkorb.initWarenkorb();
    warenkorbShop.bestellungAktualisieren();
    
    const warenkorbAnzahl = new Anzahl('.warenkorb-seite__buch-input-container', '.warenkorb-seite__buch-input-buttons--plus', '.warenkorb-seite__buch-input-buttons--minus', '.warenkorb-seite__buch-input');

    warenkorbAnzahl.initialisierungInputGroups();

    document.addEventListener('onFormieInit', (e) => {
        const $warenkorbFormie = document.querySelector('.warenkorb-seite');
        $warenkorbFormie.addEventListener('onAfterFormieSubmit', (e) => {
            warenkorbWarenkorb.warenkorbLoeschen();
            warenkorbWarenkorb.warenkorbSeiteLeeren();
        });
    });
});